import React from 'react';
import cx from 'classnames';
import { SLDSDataTable } from '@salesforce/design-system-react';

function DataTable({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSDataTable, Object.assign({}, props, {
    className: cx(className, "tds-table")
  }));
}
DataTable.displayName = "DataTable";
DataTable.propTypes = SLDSDataTable.propTypes;
DataTable.defaultProps = SLDSDataTable.defaultProps;

export { DataTable as default };
